<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <template v-for="(upElementBlocks, index) in upElementBlocksList">
        <div v-if="upElementBlocks.length > 0" :key="index" class="section form-column" :style="{width: upElementBlocks[0].width + 'px'}">
          <el-form :disabled="disabled" label-width="130px" label-position="right">
            <template v-for="(item, subIndex) in upElementBlocks">
              <span :key="subIndex" class="title" style="width: 100%;">
                {{ item.title }}
                <el-tooltip v-if="item.name === 'polAirPortInfo'" class="item" effect="dark" :content="$t('SeaExport.PolPortInfoPrompt')" placement="top-start">
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <span
                  v-if="item.name === 'podAirPortInfo' || item.name === 'airSecondVesselInfo'"
                  :key="subIndex + '2'"
                  style="font-weight: lighter;"
                >
                  {{ $t('SeaExport.LocalTime') }}
                </span>
              </span>
              <slot v-for="elementName in item.elementNames" :name="elementName" />
            </template>
          </el-form>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabVesselEqUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    upElementBlocksList() {
      const result = []
      for (let i = 1; i <= 4; ++i) {
        result.push(this.elementBlocks.filter(p => p.position === i && !p.hide))
      }
      return result
    }
  }
}
</script>
